import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '#/components/legal/legal-page'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/privacy')({ component: Page, head: () => ({ meta: [{ title: `${m.privacy_title()} · ${m.app_name()}` }] }) })

function Page() {
  const sections = [
    { h: m.privacy_1_h(), p: m.privacy_1_p() },
    { h: m.privacy_2_h(), p: m.privacy_2_p() },
    { h: m.privacy_3_h(), p: m.privacy_3_p() },
    { h: m.privacy_4_h(), p: m.privacy_4_p() },
    { h: m.privacy_5_h(), p: m.privacy_5_p() },
    { h: m.privacy_6_h(), p: m.privacy_6_p() },
    { h: m.privacy_7_h(), p: m.privacy_7_p() },
    { h: m.privacy_8_h(), p: m.privacy_8_p() },
    { h: m.privacy_9_h(), p: m.privacy_9_p() },
  ]
  return <LegalPage title={m.privacy_title()} intro={m.privacy_intro()} sections={sections} otherHref="/terms" otherLabel={m.legal_see_terms()} />
}
